module.exports = __webpack_public_path__ + "static/media/AquariumLogo-2.b5fb71d5.png";